// reducers.js

import { initialState } from './state';

export default function reducer(state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
}